<template>
  <div class="container-fluid">
    <div class="row mt-4 mb-4">
      <div class="col-6">
        <h1>Registros Cadastrados</h1>
      </div>
      <div class="col-6 text-right">
        <router-link
          to="/new"
          class="btn btn-theme py-3"
          title="Cadastrar Novo Registro da Qualidade"
        >
          Cadastrar Novo Registro da Qualidade
        </router-link>
      </div>
    </div>
    <loading-data v-if="loadData" />
    <div v-else>
      <notification
        v-if="registriesWithExpiredActions"
        :registries="registriesWithExpiredActions"
      />
      <list-registries :registries="registries" />
    </div>
  </div>
</template>

<script>
import LoadingData from '@/components/commons/LoadingData.vue'
import Notification from '@/components/notifications/Notification.vue'
import ListRegistries from '@/components/registries/ListRegistries.vue'

export default {
  name: 'Home',

  components: {
    LoadingData,
    Notification,
    ListRegistries,
  },

  data() {
    return {
      loadData: true,
      registriesWithExpiredActions: null,
      registries: null,
    }
  },

  methods: {
    async getRegistries() {
      try {
        this.registriesWithExpiredActions = await this.$store.dispatch(
          'getRegistriesWithExpiredActions',
        )
        this.registries = await this.$store.dispatch('getRegistries')
        this.loadData = false
      } catch (error) {
        if (error && error.message) {
          this.$snotify.warning(error.message, 'Atenção!')
        } else {
          this.$snotify.error(
            'Não foi possível se conectar ao servidor.',
            'Erro!',
          )
        }
      }
    },
  },

  mounted() {
    this.getRegistries()
  },
}
</script>
